<template>
  <div class="heavy-rain-gradient">
    <Navbar :scroll-position="scrollPosition" />
    <main>
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import { useScrollPosition } from '../composables/useScrollPosition'
import Navbar from '../components/common/Navbar.vue'
import Footer from '../components/common/Footer.vue'

export default {
  name: 'DefaultLayout',
  components: {
    Navbar,
    Footer
  },
  setup() {
    const { scrollPosition } = useScrollPosition()
    return {
      scrollPosition
    }
  }
}
</script>

